import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ImpactOverlayRef } from '@impactdk/ngx-overlay';
import { first } from 'rxjs/operators';
import { ConsentService } from '../../core/consent.service';
import { PanelSizes } from '../../panel/panel.component';

@Component({
    selector: 'app-personal-information-consent-overlay',
    template: `
        <app-panel [headerText]="'consent.modal_headline' | translate" [panelSize]="panelSizes.SMALL">
            <app-rich-text
                *ngIf="permissionText"
                [html]="permissionText"
            ></app-rich-text>
            <app-button
                [buttonClass]="'button--primary panel__content-button'"
                (click)="this.dialogRef.close()"
                [title]="'buttons.back' | translate"
                [loading]="loading"
            ></app-button>
        </app-panel>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersonalInformationConsentOverlayComponent {
    permissionText?: string | null;
    loading = true;
    panelSizes = PanelSizes;

    constructor(public consentService: ConsentService, public readonly dialogRef: ImpactOverlayRef, cdr: ChangeDetectorRef) {
        consentService.getCheckoutConsentText().pipe(first()).subscribe(consent => {
            this.permissionText = consent.permissionText;
            this.loading = false;
            cdr.markForCheck();
        }, () => this.loading = false);

    }
}
